import React from "react";

const Resume = () => {
    return (
        <>
            <h1></h1>
        </>
    )
}

export { Resume };